module.exports = __webpack_public_path__ + "images/80849e8afbbb9825d689583503fe3bdc.webp";